import { Stack, Typography, Button, capitalize } from '@mui/material';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';
import { getSubscriptionText } from '@shared/entity';
import { SubscriptionPlansEnum } from '../entity';

type SubscriptionInfoProps = {
  subscriptionInfo: {
    plan: string;
    billingPeriod?: string;
    endDate: string;
    status: string;
    isActive: boolean;
  };
  isChangingSubscription: boolean;
};

const SubscriptionInfo = ({ subscriptionInfo, isChangingSubscription }: SubscriptionInfoProps) => {
  if (isChangingSubscription) {
    return (
      <Stack spacing={2} alignItems="center" sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h5" color="primary" fontWeight="bold">
          <FormattedMessage id="subscriptionPage.changeTitle" defaultMessage="Změna předplatného" />
        </Typography>
        <Typography variant="body1" color="info" textAlign="center" maxWidth={600}>
          <FormattedMessage
            id="subscriptionPage.currentPlan"
            defaultMessage="Váš aktuální tarif: <strong>{plan}</strong> • Platný do: {endDate}"
            values={{
              strong: chunks => <strong>{chunks}</strong>,
              plan:
                subscriptionInfo.plan === SubscriptionPlansEnum.PRO
                  ? capitalize(SubscriptionPlansEnum.PRO)
                  : `${capitalize(SubscriptionPlansEnum.EXPERT)}${subscriptionInfo.billingPeriod === 'YEARLY' ? ' · roční' : ''}`,
              endDate: dayjs(subscriptionInfo.endDate).format('DD.MM.YYYY'),
            }}
          />
        </Typography>
        {subscriptionInfo.isActive && (
          <Button href={window.location.origin}>
            <FormattedMessage id="subscriptionPage.enterApp" defaultMessage="Přejít do aplikace" />
          </Button>
        )}
      </Stack>
    );
  }

  return (
    <>
      <Typography variant="body1" color="info" textAlign="center" maxWidth={500}>
        <FormattedMessage
          id="subscriptionPage.yourSubscription"
          values={{
            strong: chunks => <strong>{chunks}</strong>,
            subscriptionText: getSubscriptionText(
              dayjs(subscriptionInfo.endDate).toDate(),
              subscriptionInfo.status,
            ),
          }}
        />
      </Typography>
      {subscriptionInfo.isActive && (
        <Button href={window.location.origin}>
          <FormattedMessage id="subscriptionPage.enterApp" defaultMessage="Přejít do aplikace" />
        </Button>
      )}
    </>
  );
};
export default SubscriptionInfo;
